export const homeTranslations =  {
    // Nav bar
    nav: {
      services: "Services",
      community: "Community",
      events: "Events",
      blog: "Blog",
      contact: "Contact",
      signin: "Sign In",
      getStarted: "Get Started"
    },
    // Hero Section
    hero: {
      title: "Level Up Your Testing Game",
      subtitle: "At Quality Nexus, we deliver high-impact software testing solutions while nurturing a thriving global community of QA engineers.",
      exploreServices: "Explore Services",
      joinCommunity: "Join the Community"
    },
    // Services Section
    services_section: {
      title: "Our Testing Services",
      description: "Comprehensive QA solutions tailored to your project needs. Our expert team delivers quality at every step of the development lifecycle.",
      learnMore: "Learn More",
      viewAll: "View All Services",
      cards: {
        functionalTesting: {
          title: "Functional Testing",
          description: "Ensure your software works as expected with comprehensive functional testing services."
        },
        testAutomation: {
          title: "Test Automation",
          description: "Accelerate delivery with intelligent test automation strategies and implementation."
        },
        performanceTesting: {
          title: "Performance & Load Testing",
          description: "Validate your application's performance under various load conditions."
        },
        securityTesting: {
          title: "Security & Vulnerability Testing",
          description: "Identify and mitigate security risks before they impact your business."
        },
        usabilityTesting: {
          title: "Usability & UX Testing",
          description: "Optimize user experience with expert UX evaluation and testing."
        },
        apiTesting: {
          title: "API & Integration Testing",
          description: "Ensure seamless integration between components and third-party services."
        },
        qaConsulting: {
          title: "QA Process Consulting",
          description: "Optimize your QA processes with expert guidance and best practices."
        },
        testStrategy: {
          title: "Test Strategy Design",
          description: "Develop comprehensive test strategies tailored to your project needs."
        },
        accessibilityTesting: {
          title: "Accessibility Testing",
          description: "Make your software accessible to all users with specialized testing."
        }
      }
    },
    // Community Section
    community: {
      communityLabel: "Community Platform",
      title: "A full platform built for software testers",
      description: "The Quality Nexus Community Platform brings profiles, networking, mentorship, learning and opportunities together in one place — so you can grow your QA career with people who get it.",
      features: {
        profile: {
          title: "Professional Tester Profiles",
          description: "Build a rich QA profile with skills, experience, certifications and portfolio."
        },
        feed: {
          title: "Social Feed & Discussions",
          description: "Share updates, ask questions and join threaded Q&A with the testing community."
        },
        connections: {
          title: "Connections & Messaging",
          description: "Follow testers, grow your network and chat directly with peers and experts."
        },
        mentorship: {
          title: "Mentorship & Study Groups",
          description: "Find a mentor, become one, or learn together in focused study groups."
        }
      },
      visitCommunityButton: "Explore the Platform",
      becomeMentorButton: "Become a Mentor",
      highlights: {
        label: "Live",
        title: "Inside the Community",
        ctaButton: "Create Your Tester Profile",
        studyGroups: { title: "Study Groups", description: "Automation, API & Performance tracks", action: "Create or join a group", status: "Open now" },
        discussions: { title: "Discussions", description: "Ask, answer and share testing know-how", action: "Threaded Q&A", status: "Daily activity" }
      },
      modules: {
        title: "Also on the platform",
        roadmaps: "Learning Roadmaps",
        tools: "Tools Directory",
        events: "Events & Meetups",
        jobs: "QA Jobs Board",
        link: "See everything included"
      }
    },
    //Events Section
    events: {
      title: "Events & Announcements",
      description: "Join our upcoming events, webinars, and community meetups to enhance your testing knowledge and connect with fellow professionals.",
  
    }, 
    // Crowedsourced Section
    crowdSourced: {
      label: "Coming Soon",
      title: "Crowdsourced Testing",
      description: "Join our innovative approach to software testing that leverages the collective power of our global community.",
      testers: {
        title: "For Test Engineers",
        description: "Apply your testing skills on real projects. Earn rewards, build your profile, and grow your professional network.",
        button: "Shape Your Future Testing Experience"
      },
      businessOwners: {
        title: "For Business Owners",
        description: "Get real-world feedback from diverse testers. Improve your product quality with insights from our global testing community.",
        button: "Shape the Testing Solution You Need"
      },
      launchStatement: {
        part1: "Launch scheduled for ",
        launchDate: "Nov2026",
        part2: " — Join early for exclusive benefits"
      }
    },
    // Reviews
    reviews: {
      title: "What People Are Saying",
      description: "Hear from our clients and community members about their experience with Quality Nexus.",
      companiesTitle: "Trusted by innovative companies"
    },
    // CTA section
    ctaSection: {
      title: "Ready to level up your testing game?",
      description: "Join Quality Nexus today to elevate your testing capabilities and become part of our thriving community of quality enthusiasts.",
      servicesButton: "Explore Services",
      communityButton: "Join the Community"
    },
    // Footer
    footer: {
      about: "Level up your testing game with Quality Nexus, where expert testing services meet a thriving global community of testing and quality engineers.",
      quickLinks: {
        title: "Quick Links",
        services: "Services",
        community: "Community",
        events: "Events",
        blog: "Blog",
        contact: "Contact US",
        about: "About Us"
      },
      services: {
        title: "Services",
        mobileApps: "Mobile App Testing",
        api: "API Testing",
        performance: "Performance Testing",
        security: "Security Testing",
        all: "All Services →"
      },
      newsletter: {
        title: "Newsletter",
        description: "Subscribe to our newsletter for the latest updates, events, and community news.",
        emailPlaceholder: "Your email address",
        subscribe: "Subscribe"
      },
      copyrights: "Quality Nexus. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  };
